import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuctionHeaderPhase from '../AuctionHeaderPhase';
import AuctionHeaderProgress from '../AuctionHeaderProgress';
import HeaderProduct from '../HeaderProduct';
import { auctionType } from '../../../types';
import './_styles_/BidsHeader.css';
import AuctionHeaderNumberOfLots from './AuctionHeaderNumberOfLots';
import AuctionHeaderEnergyPerLot from './AuctionHeaderEnergyPerLot';

BidsHeader.propTypes = {
    hideHandler: PropTypes.func.isRequired,
    auction: auctionType.isRequired,
};

function BidsHeader(props) {
    const {
        hideHandler,
        auction,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="auction-bids--header">
            <div className="auction-header">
                <div className="auction-header--main">
                    {auction.product.iconSymbol && (
                        <FontAwesomeIcon icon={auction.product.iconSymbol} style={{ color: auction.product.iconColor }} size="2x" className="auction-header--product-icon" />
                    )}
                </div>
                <div className="auction-header--name">{auction.name}</div>
                <div className="auction-header--id">{auction.id}</div>
                <HeaderProduct product={auction.product} />
                <AuctionHeaderNumberOfLots numberOfLots={auction.quantity} postfix={t('auctions.bids-header.lot', { count: auction.quantity })} />
                <AuctionHeaderEnergyPerLot energyPerLot={auction.energyPerLot} unit={auction.product.quantityUnit} postfix={t('auctions.bids-header.per-lot')} />
                <AuctionHeaderProgress auction={auction} />
                <AuctionHeaderPhase phase={auction.phase} />
            </div>
            <button type="button" className="close-button button-small button-primary-text auction-bids--header--close" onClick={hideHandler}>
                <span aria-label={t('auctions.bids-list.dismiss')} role="img"><FontAwesomeIcon icon="times" /></span>
            </button>
        </div>
    );
}

export default BidsHeader;
